export default __webpack_public_path__ + "static/media/AMEX.d81327f7.svg";